import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Menu, Transition } from '@headlessui/react';
import { useDispatch } from 'redux-react-hook';
import { updateUser } from 'store/DEPRECATEDusers/asyncAction';
import styled from 'styled-components';

import settings_icon from '../../../assets/settings.svg';

export const DialogSettingsTool = props => {
  const {
    currentUser,
    hasSubscription = false,
    onChangeName = () => { },
    onPremiumClick = () => { },
    onAuthClick = () => { }
  } = props;

  const dispatch = useDispatch();

  const [difficulty, setDifficulty] = useState(currentUser?.difficulty || 'medium');
  const [descriptionStyle, setDescriptionStyle] = useState(currentUser?.descriptionStyle || 'dry');

  const handleDifficultyChange = async diff => {
    if (!currentUser) {
      onAuthClick();
      return;
    }
    if (hasSubscription == false && diff != 'medium') {
      onPremiumClick();
      return;
    }
    if (diff == currentUser.difficulty) {
      return;
    }

    const data = { ...currentUser, difficulty: diff };
    await dispatch(updateUser(data));
    setDifficulty(diff);
    toast.success('Saved');
  };

  const handleStyleChange = async style => {
    if (!currentUser) {
      onAuthClick();
      return;
    }
    if (hasSubscription == false && style != 'dry') {
      onPremiumClick();
      return;
    }
    if (style == currentUser.descriptionStyle) {
      return;
    }

    const data = { ...currentUser, descriptionStyle: style };
    await dispatch(updateUser(data));
    setDescriptionStyle(style);
    toast.success('Saved');
  };

  return (
    <Menu as="div" className="relative z-10">
      <Menu.Button className='flex items-center space-x-2 font-["Nunito_Sans"] text-lg font-bold leading-5 text-white'>
        <SettingsPlaceholder>
          <img src={settings_icon} />
        </SettingsPlaceholder>
      </Menu.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0"
      >
        <Menu.Items
          className="absolute right-0 z-10 mt-2 box-border flex w-[175px] origin-top-right flex-col rounded-xl border border-[rgb(29,29,29)] bg-[rgb(16,13,11)] px-4 shadow-sm ring-1 ring-black ring-opacity-5 focus:outline-none"
          anchor="bottom"
        >
          <Menu.Item onClick={onChangeName}>
            <span className="block cursor-pointer border-b border-b-[rgb(29,29,29)] py-4 text-base leading-5 text-white hover:text-gray-200">
              Change Name
            </span>
          </Menu.Item>
          <Menu.Item>
            <div className="flex flex-col border-b border-b-[rgb(29,29,29)]">
              <span className="block cursor-pointer py-4 text-base leading-5 text-white hover:text-gray-200">
                Difficulty:
              </span>
              <div className="flex flex-col gap-y-4 pb-4">
                <div
                  className="flex cursor-pointer gap-x-2 text-white"
                  onClick={() => {
                    handleDifficultyChange('easy');
                  }}
                >
                  <Radio
                    type="checkbox"
                    checked={difficulty == 'easy'}
                    className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                    onChange={() => { }}
                  />

                  <CheckboxLabel isPremium={true}>Easy</CheckboxLabel>
                </div>
                <div
                  className="flex cursor-pointer gap-x-2 text-white"
                  onClick={() => {
                    handleDifficultyChange('medium');
                  }}
                >
                  <Radio
                    type="checkbox"
                    checked={difficulty == 'medium'}
                    className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                    onChange={() => { }}
                  />

                  <CheckboxLabel isPremium={false}>Medium</CheckboxLabel>
                </div>
                <div
                  className="flex cursor-pointer gap-x-2 text-white"
                  onClick={() => {
                    handleDifficultyChange('hard');
                  }}
                >
                  <Radio
                    type="checkbox"
                    checked={difficulty == 'hard'}
                    className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                    onChange={() => { }}
                  />

                  <CheckboxLabel isPremium={true}>Hard</CheckboxLabel>
                </div>
              </div>
            </div>
          </Menu.Item>
          <Menu.Item>
            <div className="flex flex-col">
              <span className="block cursor-pointer py-4 text-base leading-5 text-white hover:text-gray-200">
                Description style:
              </span>
              <div className="flex flex-col gap-y-4 pb-4">
                <div
                  className="flex cursor-pointer gap-x-2 text-white"
                  onClick={() => {
                    handleStyleChange('dry');
                  }}
                >
                  <Radio
                    type="checkbox"
                    checked={descriptionStyle == 'dry'}
                    className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                    onChange={() => { }}
                  />

                  <CheckboxLabel isPremium={false}>Dry and short</CheckboxLabel>
                </div>
                <div
                  className="flex cursor-pointer gap-x-2 text-white"
                  onClick={() => {
                    handleStyleChange('poetic');
                  }}
                >
                  <Radio
                    type="checkbox"
                    checked={descriptionStyle == 'poetic'}
                    className="border-none focus:ring-0 focus:ring-transparent focus:ring-offset-0"
                    onChange={() => { }}
                  />

                  <CheckboxLabel isPremium={true}>Poetic</CheckboxLabel>
                </div>
              </div>
            </div>
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

const SettingsPlaceholder = styled.div`
  background-color: #100D0B;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 50;
`;

const Radio = styled.input`
  width: 20px;
  height: 20px;
  background: linear-gradient(
    90deg,
    rgba(158, 94, 238, 0.15) 0%,
    rgba(183, 89, 234, 0.15) 32%,
    rgba(198, 93, 233, 0.15) 66%,
    rgba(184, 133, 244, 0.15) 100%
  );
  border-radius: 20px;
  cursor: pointer;

  :checked {
    background-color: rgba(255, 126, 85, 1) !important;
  }
`;

const CheckboxLabel = styled.span`
  background: ${props =>
    props?.isPremium
      ? 'linear-gradient(90deg, #9E5EEE 0%, #B759EA 32%, #C65DE9 66%, #B885F4 100%)'
      : ''};
  padding: 2px 6px;
  border-radius: 20px;
  color: white;
  font-size: 16px;
  line-height: 18px;
  font-family: 'Nunito Sans';
  ::first-letter {
    text-transform: uppercase;
  }
`;
